import React from 'react';
import {Card,Title,Content,Icon} from './ResumeCard'

import iconSet from "../../icons/selection.json";
import IcomoonReact, { iconList } from "icomoon-react";


export default function Refcard(props){

    const {title,content,iconname, ...otherProps} = props;

return(
    
    <Card>
        <Icon>
        <IcomoonReact iconSet={iconSet} color="#606c88" style={{ height: "3rem", width: "3rem", margin: "0 auto" }} icon={iconname} />
        </Icon>

        <Title>
           {title}
        </Title>

        <Content>
           {content}
        </Content>
        
        {/* <p> {qoute} </p> 

        <Wrapper>

            <Pic src= {require(`../../img/${imageName}.jpg`)} alt="Hamisu Lawal" />
            <Name>{name}</Name>

           
        </Wrapper> */}
        

    </Card>
    
)

}